<template>
  <bg-style v-if="enabled" :bg="model.unlimitedBackground" :radius="model.cardRadius" class="unlimited-tier-wrap"
    :class="{ 'is-mobile': $store.getters.isMobile }" :style="unlimitedTierStyle">
    <div class="left-part">
      <bg-style :bg="model.unlimitedIcon" class="icon-box">
        <img v-if="!model.unlimitedIcon.backgroundImage"
          src="https://kopglobal.com/site-builder/prod/1713777236079_20240403-180959.png" class="default-icon" />
      </bg-style>
      <div class="progress-text">
        {{ moreLevel.received_num }} / <span v-if="moreLevel.max_num" class="ml-1">{{ moreLevel.max_num }}</span><i v-else class="iconfont ml-1 relative top-[1px] icon-wuxian text-[20px]" />
      </div>
    </div>
    <div class="right-part">
      <div class="desc">
        <i18n path="siteBuild.activity.payToMaxLevel">
          <template slot="val">
            {{ maxLevel.virtual_currency_val }}
            <span v-if="activityData.add_credit_type === 2">{{ activityData.country_currency }}</span>
            <img v-else-if="activityData.virtual_currency_icon" :src="activityData.virtual_currency_icon" alt class="max-w-[20px] max-h-[20px] inline mx-2 object-contain" />
          </template>
        </i18n>
        <i18n path="siteBuild.activity.payMoreGetReward">
          <template slot="val">
            {{ moreLevel.currency_val }}
            <span v-if="activityData.add_credit_type === 2">{{ activityData.country_currency }}</span>
            <img v-else-if="activityData.virtual_currency_icon" :src="activityData.virtual_currency_icon" alt class="max-w-[20px] max-h-[20px] inline mx-2 object-contain" />
          </template>
        </i18n>
        {{ $t('siteBuild.activity.getOneReward') }}
      </div>
      <div class="rewards-area">
        <div class="rewards-list">
          <div class="reward-item" v-for="(item, index) in moreLevel.gift_list" :key="item.gift_goods_id + index"
            :style="{ '--level-bg': `url('${item.level_icon}')` }" @click="handleShowReward(item)">
            <img :src="item.logo" class="reward-icon" />
            <span class="count">{{ item.num }}</span>
          </div>
        </div>
        <div class="action-btn">
          <bg-style :style="buttonStyle" :radius="model.cardRadius" class="button" @click.native="handleUnlimitedClaim"
            :bg="moreLevel.left_num > 0 ? model.getBackground : model.disabledBackground">
            <div class="relative">
              <i v-if="loading" class="el-icon-loading" style="margin-right: 4px;"></i>
              {{ $t('siteBuild.activity.get') }} <span v-if="moreLevel.left_num > 1">X {{ moreLevel.left_num }}</span>
            </div>
          </bg-style>
        </div>
      </div>
    </div>
  </bg-style>
</template>

<script setup>
import { computed, getCurrentInstance, ref } from 'vue'
import { Message } from 'element-ui'
import Bus from '~/site/model/bus'
import { BusEventMap } from '~/enums/data'
import { getTextColor } from '~/utils'

const props = defineProps({
  activityData: Object,
  editing: Boolean,
  model: {
    type: Object,
    default() {
      return {}
    }
  }
})
const { proxy } = getCurrentInstance()
const loading = ref(false)

// const currencyLabel = computed(() => {
//   return proxy.$store.state.project.currencieMap?.[props.activityData.country_currency]?.label
// })
const emit = defineEmits(['show-detail'])
const maxLevel = computed(() => {
  return props.activityData.activity_level_hit_list?.[props.activityData.activity_level_hit_list.length - 1] || {}
})
const moreLevel = computed(() => {
  return props.activityData.more_level || {}
})

const textColor = computed(() => {
  return getTextColor(props.model.textColor).color
})

const buttonTextColor = computed(() => {
  return getTextColor(props.model.getTextColor).color
})

const unlimitedTierStyle = computed(() => {
  return {
    '--card-border-radius': (props.model.cardRadius || 0) + 'px',
    '--card-shadow': (props.model.cardShadow || 0) + 'px',
    '--text-color': textColor.value,
    boxShadow: `0 0 var(--card-shadow) rgba(0,0,0,0.1)`,
    borderRadius: `var(--card-border-radius)`
  }
})

const enabled = computed(() => {
  const baseEnabled = moreLevel.value.currency_val && moreLevel.value.gift_list?.length > 0
  if (!baseEnabled) return false

  if (props.editing) return true

  const isLogin = proxy.$store.getters.userId
  if (!isLogin) return false

  const showAfterLevel = moreLevel.value.show_after_level
  if (!showAfterLevel) return true

  const currentVal = props.activityData.virtual_currency_num || 0
  return currentVal >= showAfterLevel
})

const buttonStyle = computed(() => {
  return {
    color: moreLevel.value.left_num > 0 ? buttonTextColor.value : getTextColor(props.model.disabledTextColor).color
  }
})

const handleShowReward = (item) => {
  if (props.editing) return
  const reward = {
    ...item,
    gift_goods_logo: item.logo,
    gift_goods_name: item.gift_name
  }
  const detail = { gift_list: [reward] }
  emit('show-detail', detail)
}

const handleUnlimitedClaim = async () => {
  if (props.editing || moreLevel.value.left_num <= 0 || loading.value) return

  loading.value = true
  const params = {
    activity_id: props.activityData.biz_id
  }

  try {
    const [err] = await proxy.$utils.to(proxy.$api.activity.accumulationMoreLevelPick(params))
    if (err) {
      Message.error(err)
      return
    }
    Message.success('Success')
    Bus.$emit('reloadActivity')
    Bus.$emit(BusEventMap.RefreshLottery)
  } finally {
    loading.value = false
  }
}
</script>

<style lang="less" scoped>
.unlimited-tier-wrap {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  margin-top: 16px;

  .left-part {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 16px;
    flex-shrink: 0;
    position: relative;

    .icon-box {
      width: 56px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;

      .default-icon {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .progress-text {
      margin-top: 6px;
      font-size: 16px;
      font-weight: 600;
      color: var(--text-color);
      display: flex;
      align-items: center;
    }
  }

  .right-part {
    flex: 1;
    min-width: 0;
    position: relative;

    .desc {
      font-size: 16px;
      margin-bottom: 14px;
      line-height: 1.5;
      color: var(--text-color);
      // display: flex;
      // align-items: center;
    }

    .rewards-area {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .rewards-list {
        display: flex;
        gap: 10px;
        overflow-x: auto;
        padding-bottom: 4px;

        &::-webkit-scrollbar {
          height: 0;
          display: none;
        }

        .reward-item {
          position: relative;
          width: 56px;
          height: 56px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          background: var(--level-bg) no-repeat;
          background-size: 100% 100%;
          cursor: pointer;

          .reward-icon {
            width: 42px;
            height: 42px;
            object-fit: contain;
          }

          .count {
            position: absolute;
            bottom: 0;
            right: 0;
            font-size: 11px;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            padding: 1px 4px;
            border-top-left-radius: 4px;
            border-bottom-right-radius: 4px;
            line-height: 1.2;
          }
        }
      }

      .action-btn {
        margin-left: 16px;
        flex-shrink: 0;

        .button {
          border: none;
          padding: 8px 16px;
          border-radius: 24px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          white-space: nowrap;

          &:hover {
            opacity: 0.9;
          }
        }
      }
    }
  }

  &.is-mobile {
    .right-part {
      .desc {
        font-size: 14px;
      }
    }
  }
}
</style>
